
export default {
  name: "CrmDealCard",
  props: {
    oportunidade: {
      type: Object,
      required: true,
    },
    draggable: {
      type: Boolean,
      default: true,
    },
    dragging: {
      type: Boolean,
      default: false,
    },
    showActions: {
      type: Boolean,
      default: true,
    },
    temperatureOptions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    contactText() {
      return (
        this.oportunidade.contato ||
        this.oportunidade.pessoa ||
        "Sem cliente ou contato"
      );
    },
    contactPhone() {
      return (
        this.oportunidade.contato_telefone ||
        this.oportunidade.telefone_contato ||
        this.oportunidade.pessoa_telefone ||
        ""
      );
    },
    isLate() {
      return (
        this.oportunidade.proxima_atividade_em &&
        new Date(this.oportunidade.proxima_atividade_em) < new Date()
      );
    },
    hasNoNextAction() {
      return !this.oportunidade.proxima_atividade_em;
    },
    nextActionText() {
      if (!this.oportunidade.proxima_atividade_em) {
        return "Sem próxima ação";
      }

      return new Date(this.oportunidade.proxima_atividade_em).toLocaleString(
        "pt-BR"
      );
    },
    temperatureOption() {
      return this.temperatureOptions.find(
        (option) => option.value === this.oportunidade.temperatura
      );
    },
    temperatureText() {
      if (this.temperatureOption && this.temperatureOption.text) {
        return this.temperatureOption.text;
      }

      const labels = {
        muito_frio: "Muito frio",
        frio: "Frio",
        morno: "Morno",
        quente: "Quente",
        venda_certa: "Venda certa",
      };

      return labels[this.oportunidade.temperatura] || "Sem temperatura";
    },
    temperatureIcon() {
      const icons = {
        muito_frio: "la la-thermometer-empty",
        frio: "la la-thermometer-quarter",
        morno: "la la-thermometer-half",
        quente: "la la-thermometer-three-quarters",
        venda_certa: "la la-thermometer-full",
      };

      return icons[this.oportunidade.temperatura] || "la la-thermometer-empty";
    },
    temperatureStyle() {
      const color =
        this.temperatureOption?.cor ||
        this.oportunidade.cor ||
        this.oportunidade.etapa_cor ||
        (this.isLate ? "#f64e60" : "#0bb7d4");

      return {
        borderColor: color,
        color,
      };
    },
  },
  methods: {
    onDragStart(event) {
      if (!this.draggable) {
        event.preventDefault();
        return;
      }

      if (event.dataTransfer) {
        event.dataTransfer.effectAllowed = "move";
        event.dataTransfer.setData(
          "text/plain",
          String(this.oportunidade.id_crm_oportunidade)
        );
      }

      this.$emit("drag-start", this.oportunidade);
    },
  },
};
